<div class="reports__table table--fullHeight table--fullAdaptable">
  
  <!-- Header -->
  <div class="reports__tableHeader">
    <h3>Créditos aprobados</h3>
    <div class="columnSelector">
      <label>Columnas:</label>
      <p-multiSelect [options]="availableColumns" [(ngModel)]="selectedColumns" (ngModelChange)="onSelectedColumnsChange($event)" optionLabel="header" optionDisabled="locked" [showToggleAll]="true" [maxSelectedLabels]="1" [selectedItemsLabel]="'{0} seleccionadas'" placeholder="0 seleccionadas" styleClass="multiselect-columns" emptyFilterMessage="No se encontraron resultados"></p-multiSelect>
    </div>
  </div>

  <!-- Filters -->
  <div class="reports__tableFilters">
    <div class="filters__date">
      <div class="filters__title">
        <h4>Filtrar por período</h4>
      </div>
      <div class="filters__dateBlock">
        <div class="filters__dateGroup">
          <div class="filters__dateField">
            <label class="filters__dateLabel">Desde:</label>
            <p-calendar [(ngModel)]="dateFrom" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="Seleccionar..." appendTo="body" panelStyleClass="filters__dateCustom" styleClass="filters__dateCalendar"></p-calendar>
          </div>

          <div class="filters__dateField">
            <label class="filters__dateLabel">Hasta:</label>
            <p-calendar [(ngModel)]="dateTo" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="Seleccionar..." appendTo="body" panelStyleClass="filters__dateCustom" styleClass="filters__dateCalendar"></p-calendar>
          </div>
        </div>

        <div class="filters__dateActions">
          <div class="filters__dateButton">
            <button pButton pRipple label="Filtrar" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow" (click)="onDateFilter()"></button>
          </div>
          <div class="filters__dateButton">
            <p-button label="Limpiar" icon="pi pi-trash" iconPos="right" [text]="true" [plain]="true" (click)="clearFilters()"></p-button>
          </div>
        </div>
      </div>
    </div>

    <div class="filters__search">
      <div class="filters__title">
        <h4>Buscar por nombre, marca o IMEI</h4>
      </div>
      <div class="filters__searchBlock">
        <span class="p-input-icon-right filters__searchInput">
          <input pInputText type="text" [(ngModel)]="searchText" (input)="filterData()" placeholder="Buscar..." />
          <i class="pi pi-search"></i>
        </span>
      </div>
    </div>
  </div>

  <!-- Datatable -->
  <div class="reports__tableDatatable">
    <p-table [value]="filteredRecords" [paginator]="true" [rows]="rowsPerPage" [rowsPerPageOptions]="rowsPerPageOptions" [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [scrollable]="true">
      
      <ng-template pTemplate="header">
        <tr class="p-datatable-titles">
          <th *ngIf="isColumnVisible('contrato')" pSortableColumn="contrato" style="min-width: 8.4375rem">
            <div class="th-title">
              <span>Contrato</span>
              <p-sortIcon field="contrato"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('identidad')" pSortableColumn="identidad" style="min-width: 8.125rem">
            <div class="th-title">
              <span>Identidad</span>
              <p-sortIcon field="identidad"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('cliente')" pSortableColumn="cliente" style="min-width: 16.875rem">
            <div class="th-title">
              <span>Cliente</span>
              <p-sortIcon field="cliente"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('producto')" pSortableColumn="producto" style="min-width: 16.875rem">
            <div class="th-title">
              <span>Producto financiado</span>
              <p-sortIcon field="producto"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('imei')" pSortableColumn="imei" style="min-width: 8.75rem">
            <div class="th-title">
              <span>IMEI</span>
              <p-sortIcon field="imei"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('estado')" pSortableColumn="estado" style="min-width: 10.625rem">
            <div class="th-title">
              <span>Estado del crédito</span>
              <p-sortIcon field="estado"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('pagoAliado')" pSortableColumn="pagoAliado" style="min-width: 9.375rem">
            <div class="th-title">
              <span>Pago al aliado</span>
              <p-sortIcon field="pagoAliado"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('valorTotal')" pSortableColumn="valorTotal" style="min-width: 7.5rem">
            <div class="th-title th-title--right">
              <span>Valor total</span>
              <p-sortIcon field="valorTotal"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('financiado')" pSortableColumn="financiado" style="min-width: 7.5rem">
            <div class="th-title th-title--right">
              <span>Financiado</span>
              <p-sortIcon field="financiado"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('anticipo')" pSortableColumn="anticipo" style="min-width: 7.5rem">
            <div class="th-title th-title--right">
              <span>Anticipo</span>
              <p-sortIcon field="anticipo"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('fechaSolicitud')" pSortableColumn="fechaSolicitud" style="min-width: 7.5rem">
            <div class="th-title">
              <span>Fecha solicitud</span>
              <p-sortIcon field="fechaSolicitud"></p-sortIcon>
            </div>
          </th>
          <th *ngIf="isColumnVisible('ultimaActualizacion')" pSortableColumn="ultimaActualizacion" style="min-width: 7.5rem">
            <div class="th-title">
              <span>Ultima act.</span>
              <p-sortIcon field="ultimaActualizacion"></p-sortIcon>
            </div>
          </th>
          <th style="width: 7.8125rem">&nbsp;</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-record>
        <tr class="p-datatable-content p-datatable-content--hover" (click)="onRowClick(record)">
          <td *ngIf="isColumnVisible('contrato')">
            <div class="td-text">
              <p class="upper strong">{{ record.contrato }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('identidad')">
            <div class="td-text">
              <p>{{ record.identidad }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('cliente')">
            <div class="td-text">
              <p class="upper">{{ record.cliente }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('producto')">
            <div class="td-text">
              <p>{{ record.producto }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('imei')">
            <div class="td-text">
              <p>{{ record.imei }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('estado')">
            <div class="td-text">
              <div class="status-tag" [ngClass]="getStatusSeverityClass(record.estadoSeverity)">
                <span>{{ record.estado }}</span>
              </div>
            </div>
          </td>
          <td *ngIf="isColumnVisible('pagoAliado')">
            <div class="td-text">
              <div class="appliedPay-tag" [ngClass]="getAllyPaymentSeverityClass(record.pagoAliadoSeverity)">
                <i [class]="getAllyPaymentIcon(record.pagoAliadoSeverity)"></i>
                <span>{{ record.pagoAliado }}</span>
              </div>
            </div>
          </td>
          <td *ngIf="isColumnVisible('valorTotal')">
            <div class="td-text td-text--right">
              <p>{{ record.valorTotal }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('financiado')">
            <div class="td-text td-text--right">
              <p class="strong">{{ record.financiado }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('anticipo')">
            <div class="td-text td-text--right">
              <p>{{ record.anticipo }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('fechaSolicitud')">
            <div class="td-text">
              <p>{{ record.fechaSolicitud }}</p>
            </div>
          </td>
          <td *ngIf="isColumnVisible('ultimaActualizacion')">
            <div class="td-text">
              <p>{{ record.ultimaActualizacion }}</p>
            </div>
          </td>
          <td style="width: 7.8125rem">
            <div class="td-btn">
              <button pButton pRipple label="PDF" icon="pi pi-download" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow" (click)="$event.stopPropagation(); onDownloadPdf(record)"></button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="p-datatable-content">
          <td [attr.colspan]="selectedColumns.length + 1">
            <div class="td-empty">
              <p>No se encontraron registros para los filtros aplicados.</p>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>
